import { NavContent } from "./NavContent";
import { Dashboard } from "./Dashboard";
import { AppTitleRight } from "./AppTitleRight";
import { pathHome } from "../../businessLogic/constants/path";
import { anchorOrigin, autoHideDuration, maxSnack } from "../../businessLogic/constants/notiStack";
import { SnackbarProvider } from "notistack";
//import { TempLogin } from "./TempLogin";

export const dashboard = () => [
  {
    target: "$ONE_TOOLBAR_CONTENT_RIGHT",
    priority: 1000,
    handler: { 
      component: AppTitleRight,
      props: {
        basePath: pathHome
      }
    }
  },
  {
    target: "$ONE_LAYOUT_NAV_CONTENT",
    handler: {
      component: NavContent,
      props: {
        basePath: pathHome
      }
    }
  },
  {
    target: "$ONE_LAYOUT_ROUTE",
    handler: {
      exact: true,
      path: pathHome,
      element: 
      <SnackbarProvider anchorOrigin={anchorOrigin} autoHideDuration={autoHideDuration} maxSnack={maxSnack}>
        <Dashboard basePath={pathHome} />        
      </SnackbarProvider>
    }
  }
];
